/* eslint-disable no-undef */
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { initializeApp } from 'firebase/app'
import { setLocal } from './helper/storage'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

let messaging = null
const firebaseApp = initializeApp(firebaseConfig)
if ('serviceWorker' in navigator) {
  messaging = getMessaging(firebaseApp)
}

export const requestFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')

      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration: registration
      })

      onMessage(messaging, (payload) => {
        const { title, body, icon } = payload.notification
        registration.showNotification(title, { body, icon })
      })

      if (token) {
        setLocal('device_token', token || '')
        // Return the token
        return token
      } else {
        console.warn('No FCM token received.')
        return null // Explicitly return null if no token is received
      }

      // Listen for foreground messages
    } else {
      console.error('Notification permission denied.')
      return null // Return null if permission is denied
    }
  } catch (error) {
    console.error('Error getting FCM token:', error)
    return null // Return null if an error occurs
  }
}
